import * as Highcharts from "highcharts";
import { GenericUtils } from "../../../utilities/generic-utils";
const utils = new GenericUtils ();
// chart with 2 lines

export const chartData = {
  credits: { enabled: false },
  chart: {
    type: "column"
  },

  title: {
    text: ""
  },
  legend: {
    itemStyle: {
      color: "#6b778c",
      "font-weight": "normal",
     
    },
    reversed: true
  },

  xAxis: {
    categories: ["North Central", "North West", "North East", "East", "West MAH", "South 3C", "West"]
  },

  yAxis: [
    {
      allowDecimals: false,
      min: 0,
      title: {
        text: "No. of Units"
      },
      labels: {
        style: { fontSize: "12px" },
        
      }
    }
  ],

  tooltip: {
    shared: true,
    formatter: function () {
      return 'Total units ordered:' + ': ' + utils.amountIndianUnit(this.points.map(ele => {
        return ele.y
      }).reduce((a, b) => a + b, 0)) + '</b><br>' +
        this.points.map(ele => {
          return '</b><br>' + ele.series.name + ': ' + utils.amountIndianUnit(ele.y)
        })
    }

  },

  plotOptions: {
    column: {
      stacking: "normal"
    }
  },

  series: [
    {
      name: "Delivered",
      data: [381, 349, 380, 654, 150, 550, 430],
      index:3,
      // data: [],
      stack: "male",
      color: "#73C8B1",
      // tooltip: { valueSuffix: "k" }
    },
    {
      name: "In Transit",
      // data: [],
      data: [197, 167, 203, 324, 125, 425, 540],
      index:2,
      stack: "male",
      color: "#F58F0F",
      // tooltip: { valueSuffix: "k" }
    },
    {
      name: "BBND",
      // data: [],
      data: [184, 182, 177, 330, 100, 300, 650],
      index:1,
      stack: "male",
      color: "#EAC745",
      // tooltip: { valueSuffix: "k" }
    },
    {
      name: "To be invoiced",
      data: [184, 182, 177, 330, 200, 600, 760],
      index:0,
      stack: "male",
      color: "#CF263D",
      // tooltip: { valueSuffix: "k" }
    },
  ]
};
